<template>
     <div 
        class="history-items"
        @scroll="handleScroll"
    >
        <!-- HISTORY HEAD START  -->
        <div class="history-item history-item_head history-item_p0">
            <div class="history-item__head">  
                <div class="history-item__nav">
                    <div class="history-item__id">
                        id
                    </div> 
                    <div class="history-item__days">
                        Days
                    </div> 
                    <div class="history-item__orders">
                        Orders quantity
                    </div>
                    <div class="history-item__masters">
                        Masters
                    </div> 
                    <div class="history-item__date">
                        Date
                    </div>
                    <div class="history-item__cof">
                        Handymen efficiency 
                        
                        <div class="history-item__sort">
                            <span 
                                @click="sort('sold_hours', 'asc')"
                                class="history-item__sort_asc history-item__sort_mark" 
                                ref="sold_hours_asc" 
                            >
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 612.002 612.002" style="enable-background:new 0 0 612.002 612.002;" xml:space="preserve">
                                    <g>
                                        <g>
                                            <path d="M592.639,358.376L423.706,189.439c-64.904-64.892-170.509-64.892-235.421,0.005L19.363,358.379
                                                c-25.817,25.817-25.817,67.674,0,93.489c25.817,25.817,67.679,25.819,93.491-0.002l168.92-168.927
                                                c13.354-13.357,35.092-13.361,48.444-0.005l168.93,168.932c12.91,12.907,29.825,19.365,46.747,19.365
                                                c16.915,0,33.835-6.455,46.747-19.365C618.456,426.051,618.456,384.193,592.639,358.376z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </svg>
                            </span>
                            <span 
                                @click="sort('sold_hours', 'desc')"
                                class="history-item__sort_desc history-item__sort_mark" 
                                ref="sold_hours_desc" 
                            >
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 612.002 612.002" style="enable-background:new 0 0 612.002 612.002;" xml:space="preserve">
                                    <g>
                                        <g>
                                            <path d="M592.639,358.376L423.706,189.439c-64.904-64.892-170.509-64.892-235.421,0.005L19.363,358.379
                                                c-25.817,25.817-25.817,67.674,0,93.489c25.817,25.817,67.679,25.819,93.491-0.002l168.92-168.927
                                                c13.354-13.357,35.092-13.361,48.444-0.005l168.93,168.932c12.91,12.907,29.825,19.365,46.747,19.365
                                                c16.915,0,33.835-6.455,46.747-19.365C618.456,426.051,618.456,384.193,592.639,358.376z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="history-item__cof">
                        First DoS
                        
                        <div class="history-item__sort">
                            <span 
                                @click="sort('first_denied', 'asc')" 
                                class="history-item__sort_asc history-item__sort_mark" 
                                ref="first_denied_asc"  
                            >
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 612.002 612.002" style="enable-background:new 0 0 612.002 612.002;" xml:space="preserve">
                                    <g>
                                        <g>
                                            <path d="M592.639,358.376L423.706,189.439c-64.904-64.892-170.509-64.892-235.421,0.005L19.363,358.379
                                                c-25.817,25.817-25.817,67.674,0,93.489c25.817,25.817,67.679,25.819,93.491-0.002l168.92-168.927
                                                c13.354-13.357,35.092-13.361,48.444-0.005l168.93,168.932c12.91,12.907,29.825,19.365,46.747,19.365
                                                c16.915,0,33.835-6.455,46.747-19.365C618.456,426.051,618.456,384.193,592.639,358.376z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </svg>
                            </span>
                            <span 
                                @click="sort('first_denied', 'desc')"
                                class="history-item__sort_desc history-item__sort_mark" 
                                ref="first_denied_desc" 
                            >
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 612.002 612.002" style="enable-background:new 0 0 612.002 612.002;" xml:space="preserve">
                                    <g>
                                        <g>
                                            <path d="M592.639,358.376L423.706,189.439c-64.904-64.892-170.509-64.892-235.421,0.005L19.363,358.379
                                                c-25.817,25.817-25.817,67.674,0,93.489c25.817,25.817,67.679,25.819,93.491-0.002l168.92-168.927
                                                c13.354-13.357,35.092-13.361,48.444-0.005l168.93,168.932c12.91,12.907,29.825,19.365,46.747,19.365
                                                c16.915,0,33.835-6.455,46.747-19.365C618.456,426.051,618.456,384.193,592.639,358.376z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="history-item__cof">
                        Final DoS
                        
                        <div class="history-item__sort">
                            <span
                                @click="sort('final_denied', 'asc')" 
                                class="history-item__sort_asc history-item__sort_mark"
                                ref="final_denied_asc"
                            >
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 612.002 612.002" style="enable-background:new 0 0 612.002 612.002;" xml:space="preserve">
                                    <g>
                                        <g>
                                            <path d="M592.639,358.376L423.706,189.439c-64.904-64.892-170.509-64.892-235.421,0.005L19.363,358.379
                                                c-25.817,25.817-25.817,67.674,0,93.489c25.817,25.817,67.679,25.819,93.491-0.002l168.92-168.927
                                                c13.354-13.357,35.092-13.361,48.444-0.005l168.93,168.932c12.91,12.907,29.825,19.365,46.747,19.365
                                                c16.915,0,33.835-6.455,46.747-19.365C618.456,426.051,618.456,384.193,592.639,358.376z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </svg>
                            </span>
                            <span 
                                @click="sort('final_denied', 'desc')" 
                                class="history-item__sort_desc history-item__sort_mark"
                                ref="final_denied_desc"
                            >
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 612.002 612.002" style="enable-background:new 0 0 612.002 612.002;" xml:space="preserve">
                                    <g>
                                        <g>
                                            <path d="M592.639,358.376L423.706,189.439c-64.904-64.892-170.509-64.892-235.421,0.005L19.363,358.379
                                                c-25.817,25.817-25.817,67.674,0,93.489c25.817,25.817,67.679,25.819,93.491-0.002l168.92-168.927
                                                c13.354-13.357,35.092-13.361,48.444-0.005l168.93,168.932c12.91,12.907,29.825,19.365,46.747,19.365
                                                c16.915,0,33.835-6.455,46.747-19.365C618.456,426.051,618.456,384.193,592.639,358.376z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="history-item__cof">
                        Transfer
                        
                        <div class="history-item__sort">
                            <span 
                                @click="sort('carry_over', 'asc')"  
                                class="history-item__sort_asc history-item__sort_mark"
                                ref="carry_over_asc"
                            >
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 612.002 612.002" style="enable-background:new 0 0 612.002 612.002;" xml:space="preserve">
                                    <g>
                                        <g>
                                            <path d="M592.639,358.376L423.706,189.439c-64.904-64.892-170.509-64.892-235.421,0.005L19.363,358.379
                                                c-25.817,25.817-25.817,67.674,0,93.489c25.817,25.817,67.679,25.819,93.491-0.002l168.92-168.927
                                                c13.354-13.357,35.092-13.361,48.444-0.005l168.93,168.932c12.91,12.907,29.825,19.365,46.747,19.365
                                                c16.915,0,33.835-6.455,46.747-19.365C618.456,426.051,618.456,384.193,592.639,358.376z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </svg>
                            </span>
                            <span 
                                @click="sort('carry_over', 'desc')" 
                                class="history-item__sort_desc history-item__sort_mark"
                                ref="carry_over_desc"
                            >
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 612.002 612.002" style="enable-background:new 0 0 612.002 612.002;" xml:space="preserve">
                                    <g>
                                        <g>
                                            <path d="M592.639,358.376L423.706,189.439c-64.904-64.892-170.509-64.892-235.421,0.005L19.363,358.379
                                                c-25.817,25.817-25.817,67.674,0,93.489c25.817,25.817,67.679,25.819,93.491-0.002l168.92-168.927
                                                c13.354-13.357,35.092-13.361,48.444-0.005l168.93,168.932c12.91,12.907,29.825,19.365,46.747,19.365
                                                c16.915,0,33.835-6.455,46.747-19.365C618.456,426.051,618.456,384.193,592.639,358.376z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <!-- <div class="history-item__cof">
                        Сarry over
                        
                        <div class="history-item__sort">
                            <span class="history-item__sort_asc">
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 612.002 612.002" style="enable-background:new 0 0 612.002 612.002;" xml:space="preserve">
                                    <g>
                                        <g>
                                            <path d="M592.639,358.376L423.706,189.439c-64.904-64.892-170.509-64.892-235.421,0.005L19.363,358.379
                                                c-25.817,25.817-25.817,67.674,0,93.489c25.817,25.817,67.679,25.819,93.491-0.002l168.92-168.927
                                                c13.354-13.357,35.092-13.361,48.444-0.005l168.93,168.932c12.91,12.907,29.825,19.365,46.747,19.365
                                                c16.915,0,33.835-6.455,46.747-19.365C618.456,426.051,618.456,384.193,592.639,358.376z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </svg>
                            </span>
                            <span class="history-item__sort_desc">
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 612.002 612.002" style="enable-background:new 0 0 612.002 612.002;" xml:space="preserve">
                                    <g>
                                        <g>
                                            <path d="M592.639,358.376L423.706,189.439c-64.904-64.892-170.509-64.892-235.421,0.005L19.363,358.379
                                                c-25.817,25.817-25.817,67.674,0,93.489c25.817,25.817,67.679,25.819,93.491-0.002l168.92-168.927
                                                c13.354-13.357,35.092-13.361,48.444-0.005l168.93,168.932c12.91,12.907,29.825,19.365,46.747,19.365
                                                c16.915,0,33.835-6.455,46.747-19.365C618.456,426.051,618.456,384.193,592.639,358.376z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </svg>
                            </span>
                        </div>
                    </div> -->
                    <div class="history-item__cof">
                        Requested hours
                        
                        <div class="history-item__sort">
                            <span 
                                @click="sort('requested_hours', 'asc')" 
                                class="history-item__sort_asc history-item__sort_mark"
                                ref="requested_hours_asc"
                            >
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 612.002 612.002" style="enable-background:new 0 0 612.002 612.002;" xml:space="preserve">
                                    <g>
                                        <g>
                                            <path d="M592.639,358.376L423.706,189.439c-64.904-64.892-170.509-64.892-235.421,0.005L19.363,358.379
                                                c-25.817,25.817-25.817,67.674,0,93.489c25.817,25.817,67.679,25.819,93.491-0.002l168.92-168.927
                                                c13.354-13.357,35.092-13.361,48.444-0.005l168.93,168.932c12.91,12.907,29.825,19.365,46.747,19.365
                                                c16.915,0,33.835-6.455,46.747-19.365C618.456,426.051,618.456,384.193,592.639,358.376z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </svg>
                            </span>
                            <span 
                                @click="sort('requested_hours', 'desc')" 
                                class="history-item__sort_desc history-item__sort_mark"
                                ref="requested_hours_desc"
                            >
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 612.002 612.002" style="enable-background:new 0 0 612.002 612.002;" xml:space="preserve">
                                    <g>
                                        <g>
                                            <path d="M592.639,358.376L423.706,189.439c-64.904-64.892-170.509-64.892-235.421,0.005L19.363,358.379
                                                c-25.817,25.817-25.817,67.674,0,93.489c25.817,25.817,67.679,25.819,93.491-0.002l168.92-168.927
                                                c13.354-13.357,35.092-13.361,48.444-0.005l168.93,168.932c12.91,12.907,29.825,19.365,46.747,19.365
                                                c16.915,0,33.835-6.455,46.747-19.365C618.456,426.051,618.456,384.193,592.639,358.376z"/>
                                        </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </svg>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="history-item__actions"> 
                </div> 
            </div> 
        </div> 
        <!-- HISTORY HEAD END  -->

        <!-- HISTORY ITEM START  -->
        

        <div 
            v-for="item in simulations" 
            :key="item.id" 
            class="history-item history-item_p0"
        >
            <div class="history-item__head">  
                <div class="history-item__nav" @click="openTab(item)">
                    <div class="history-item__id">
                        #{{item.id}}
                    </div> 
                    <div class="history-item__days">
                        {{getNumberOfDays(item.simulation_from, item.simulation_to)}}
                    </div> 
                    <div class="history-item__orders">
                        {{item.orders_quantity}} orders
                    </div>
                    <div class="history-item__masters">
                        {{item.masters_quantity}} masters
                    </div> 
                    <div class="history-item__date"> 
                        {{dateFormat(item.created_at, 'l')}}
                    </div>
                    <div class="history-item__cof"> 
                        <span>
                            {{item.indicators.sold_hours || 0}}%
                        </span> 
                    </div>
                    <div class="history-item__cof"> 
                        <span>
                            {{item.indicators.first_denied || 0}}%
                        </span> 
                    </div>
                    <div class="history-item__cof"> 
                        <span>
                            {{item.indicators.final_denied || 0}}%
                        </span>
                    </div>
                    <div class="history-item__cof"> 
                        <span>
                            {{item.indicators.carry_over || 0}}%
                        </span>
                    </div> 
                    <div class="history-item__cof"> 
                        <span>
                            {{ Math.round(item.indicators.requested_hours) || 0}}h / {{Math.round(item.indicators.completed_hours) || 0}}h
                        </span> 
                    </div>
                </div>
                <div class="history-item__actions">

                    <div class="history-item__dashboard"> 
                        <router-link :to="{name: `Calendar`, query: { 
                            first_day: item.simulation_from,
                            last_day: item.simulation_to,
                            id: item.id,
                            db_schema: item.db_schema
                        }}"> 
                            <svg width="20px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                                    viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                <g>
                                    <g>
                                        <path d="M452,40h-24V0h-40v40H124V0H84v40H60C26.916,40,0,66.916,0,100v352c0,33.084,26.916,60,60,60h392
                                            c33.084,0,60-26.916,60-60V100C512,66.916,485.084,40,452,40z M472,452c0,11.028-8.972,20-20,20H60c-11.028,0-20-8.972-20-20V188
                                            h432V452z M472,148H40v-48c0-11.028,8.972-20,20-20h24v40h40V80h264v40h40V80h24c11.028,0,20,8.972,20,20V148z" fill="grey"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <rect x="76" y="230" width="40" height="40"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <rect x="156" y="230" width="40" height="40"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <rect x="236" y="230" width="40" height="40"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <rect x="316" y="230" width="40" height="40"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <rect x="396" y="230" width="40" height="40"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <rect x="76" y="310" width="40" height="40"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <rect x="156" y="310" width="40" height="40"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <rect x="236" y="310" width="40" height="40"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <rect x="316" y="310" width="40" height="40"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <rect x="76" y="390" width="40" height="40"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <rect x="156" y="390" width="40" height="40"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <rect x="236" y="390" width="40" height="40"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <rect x="316" y="390" width="40" height="40"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <rect x="396" y="310" width="40" height="40"/>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </router-link> 
                    </div>

                    <button
                        @click="addToCompare($event, item.id)"  
                        :data-id="item.id"
                        class="clear-btn add-to-compare" 
                        :class="{
                            'add-to-compare_show': item.comparing != null 
                        }"
                    >
                        <svg viewBox="0 0 24 24" width="20px" fill="grey" id="icon-compare">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 7.15088L11 15.7064V16.0001C11 17.23 10.7256 18.7067 9.87944 19.9053C8.99594 21.1568 7.55968 22.0001 5.5 22.0001C3.44033 22.0001 2.00406 21.1568 1.12056 19.9053C0.27439 18.7067 0 17.23 0 16.0001V15.7064L5.5 7.15088ZM2.08102 17.0001C2.1881 17.6425 2.40512 18.257 2.75444 18.7518C3.24594 19.4481 4.05967 20.0001 5.5 20.0001C6.94033 20.0001 7.75406 19.4481 8.24556 18.7518C8.59488 18.257 8.8119 17.6425 8.91898 17.0001H2.08102ZM8.16833 15.0001H2.83167L5.5 10.8494L8.16833 15.0001Z"></path>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.5 7.15088L24 15.7064V16.0001C24 17.23 23.7256 18.7067 22.8794 19.9053C21.9959 21.1568 20.5597 22.0001 18.5 22.0001C16.4403 22.0001 15.0041 21.1568 14.1206 19.9053C13.2744 18.7067 13 17.23 13 16.0001V15.7064L18.5 7.15088ZM15.081 17.0001C15.1881 17.6425 15.4051 18.257 15.7544 18.7518C16.2459 19.4481 17.0597 20.0001 18.5 20.0001C19.9403 20.0001 20.7541 19.4481 21.2456 18.7518C21.5949 18.257 21.8119 17.6425 21.919 17.0001H15.081ZM21.1683 15.0001H15.8317L18.5 10.8494L21.1683 15.0001Z"></path>
                            <path d="M12 2C12.7403 2 13.3866 2.4022 13.7324 3H21V5H13.7324C13.3866 5.5978 12.7403 6 12 6C11.2597 6 10.6134 5.5978 10.2676 5H3V3H10.2676C10.6134 2.4022 11.2597 2 12 2Z"></path>
                        </svg> 
                    </button>  

                    <button
                        @click="addToFavs($event, item.id)"  
                        class="clear-btn add-to-favs"
                        :class="{
                            'add-to-favs_show': item.favorites != null
                        }"
                    >
                        <svg class="icon icon_like" viewBox="0 -28 512.001 512" fill="grey" width="20px" xmlns="http://www.w3.org/2000/svg">
                            <path d="m256 455.515625c-7.289062 0-14.316406-2.640625-19.792969-7.4375-20.683593-18.085937-40.625-35.082031-58.21875-50.074219l-.089843-.078125c-51.582032-43.957031-96.125-81.917969-127.117188-119.3125-34.644531-41.804687-50.78125-81.441406-50.78125-124.742187 0-42.070313 14.425781-80.882813 40.617188-109.292969 26.503906-28.746094 62.871093-44.578125 102.414062-44.578125 29.554688 0 56.621094 9.34375 80.445312 27.769531 12.023438 9.300781 22.921876 20.683594 32.523438 33.960938 9.605469-13.277344 20.5-24.660157 32.527344-33.960938 23.824218-18.425781 50.890625-27.769531 80.445312-27.769531 39.539063 0 75.910156 15.832031 102.414063 44.578125 26.191406 28.410156 40.613281 67.222656 40.613281 109.292969 0 43.300781-16.132812 82.9375-50.777344 124.738281-30.992187 37.398437-75.53125 75.355469-127.105468 119.308594-17.625 15.015625-37.597657 32.039062-58.328126 50.167969-5.472656 4.789062-12.503906 7.429687-19.789062 7.429687zm-112.96875-425.523437c-31.066406 0-59.605469 12.398437-80.367188 34.914062-21.070312 22.855469-32.675781 54.449219-32.675781 88.964844 0 36.417968 13.535157 68.988281 43.882813 105.605468 29.332031 35.394532 72.960937 72.574219 123.476562 115.625l.09375.078126c17.660156 15.050781 37.679688 32.113281 58.515625 50.332031 20.960938-18.253907 41.011719-35.34375 58.707031-50.417969 50.511719-43.050781 94.136719-80.222656 123.46875-115.617188 30.34375-36.617187 43.878907-69.1875 43.878907-105.605468 0-34.515625-11.605469-66.109375-32.675781-88.964844-20.757813-22.515625-49.300782-34.914062-80.363282-34.914062-22.757812 0-43.652344 7.234374-62.101562 21.5-16.441406 12.71875-27.894532 28.796874-34.609375 40.046874-3.453125 5.785157-9.53125 9.238282-16.261719 9.238282s-12.808594-3.453125-16.261719-9.238282c-6.710937-11.25-18.164062-27.328124-34.609375-40.046874-18.449218-14.265626-39.34375-21.5-62.097656-21.5zm0 0"></path>
                        </svg>
                    </button>

                    <div class="history-item__dashboard">
                        <router-link :to="{name: `Results`, params: {
                            id: item.id
                        }, query: {
                            name: item.db_schema
                        }}"> 
                            <svg width="20px"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                    viewBox="0 0 375.148 375.148" style="enable-background:new 0 0 375.148 375.148;" xml:space="preserve">
                                <g>
                                    <g>
                                        <g>
                                            <path d="M222.076,218.936h-68.963c-5.771,0-10.449,4.678-10.449,10.449v135.314c0,5.771,4.678,10.449,10.449,10.449h68.963
                                                c5.771,0,10.449-4.678,10.449-10.449V229.385C232.525,223.614,227.847,218.936,222.076,218.936z M211.627,354.25h-48.065V239.834
                                                h48.065V354.25z"/>
                                            <path d="M358.958,136.911h-69.486c-5.771,0-10.449,4.678-10.449,10.449v217.339c0,5.771,4.678,10.449,10.449,10.449h69.486
                                                c5.771,0,10.449-4.678,10.449-10.449V147.36C369.407,141.59,364.729,136.911,358.958,136.911z M348.509,354.25h-48.588V157.809
                                                h48.588V354.25z"/>
                                            <path d="M85.717,269.613H16.231c-5.771,0-10.449,4.678-10.449,10.449v84.637c0,5.771,4.678,10.449,10.449,10.449h69.486
                                                c5.771,0,10.449-4.678,10.449-10.449v-84.637C96.166,274.292,91.488,269.613,85.717,269.613z M75.268,354.25H26.68v-63.739
                                                h48.588V354.25z"/>
                                            <path d="M370.452,10.479c-1.589-2.19-4.089-3.536-6.792-3.657L268.574,0.03c-5.771-0.433-10.8,3.895-11.233,9.665
                                                c-0.433,5.771,3.894,10.8,9.665,11.233l67.297,4.57l-123.721,96.786l-94.563-74.188c-4.038-3.198-9.803-2.976-13.584,0.522
                                                L5.26,141.613c-4.131,3.919-4.363,10.425-0.522,14.629c1.864,2.419,4.786,3.783,7.837,3.657c2.756-0.039,5.385-1.166,7.314-3.135
                                                l90.384-86.727l93.518,73.665c3.817,3.056,9.244,3.056,13.061,0L350.601,39.624l-5.227,64.896
                                                c-0.026,5.674,4.279,10.431,9.927,10.971h0.522c5.386,0.027,9.91-4.045,10.449-9.404l6.792-88.294
                                                C373.447,15.074,372.471,12.34,370.452,10.479z"/>
                                        </g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </router-link>
                    </div>
                    
                    <button 
                        class="clear-btn"
                        @click="repeatSimulation(item.request)"
                    >
                        <svg width="20px" fill="grey" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve">
                                <g>
                                    <g>
                                        <path d="M297.393,159.723l-61.57-61.574c-5.857-5.858-15.355-5.857-21.213,0c-5.858,5.858-5.858,15.355-0.001,21.213
                                            l35.965,35.967H111.399c-8.284,0-15,6.716-15,15v171.335c0,8.284,6.716,15,15,15h33.479c8.284,0,15-6.716,15-15
                                            s-6.715-14.998-14.999-14.998H126.4V185.331h124.174l-35.962,35.963c-5.857,5.858-5.857,15.355,0.001,21.213
                                            c2.929,2.929,6.768,4.393,10.606,4.393c3.839,0,7.678-1.465,10.607-4.394l61.567-61.57
                                            C303.25,175.078,303.25,165.581,297.393,159.723z"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <path d="M400.599,155.331H367.12c-8.284,0-15,6.716-15,15s6.716,15,15,15h18.478v141.335H261.429l35.96-35.96
                                            c5.858-5.857,5.858-15.355,0-21.213c-5.857-5.858-15.355-5.858-21.213,0l-61.567,61.566c-5.858,5.857-5.858,15.355-0.001,21.213
                                            l61.57,61.574c2.929,2.929,6.768,4.393,10.607,4.393c3.838,0,7.678-1.464,10.607-4.393c5.858-5.858,5.858-15.355,0-21.213
                                            l-35.966-35.968h139.171c8.284,0,15-6.716,15-15V170.331C415.599,162.046,408.883,155.331,400.599,155.331z"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <path d="M416.665,0H95.333C42.766,0,0,42.766,0,95.333v321.333c0,52.567,42.766,95.333,95.333,95.333h321.332
                                            c52.567,0,95.334-42.766,95.334-95.333V95.333C511.999,42.766,469.232,0,416.665,0z M481.999,416.666
                                            c0,36.025-29.309,65.333-65.334,65.333H95.333C59.308,481.999,30,452.691,30,416.666V95.333C30,59.308,59.308,30,95.333,30
                                            h321.332c36.025,0,65.334,29.308,65.334,65.333V416.666z"/>
                                    </g>
                                </g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                </svg>
                    </button> 
                </div> 
            </div>
            
            <history-item-body  
                :ref="`history-item__body_${item.id}`"
                :class="`history-item__body_p10 history-item_${item.id}`" 
                :item="item"
            />
        </div>    
        <!-- HISTORY ITEM END  -->
    </div> 
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import historyItemBody from '@/components/lists/history/itemBody';
import dateMixin from '@/mixins/dateMixin';
import Vue from 'vue';

export default {
    props: {
        simulations: {
            required: true,
            type: Array
        } 
    },
    mixins: [dateMixin],
    components: {
        historyItemBody
    },  
    data(){
        return {
            sorkMarks: null
        }
    },
    computed: {
        ...mapGetters({
            params: 'simulation/params'
        })
    },
    methods: { 
        ...mapMutations({
            resetCurrentPage: 'simulation/resetCurrentPage'
        }),
        ...mapActions({ 
            compare: 'comparing/add',
            removeCompare: 'comparing/remove',
            getByName: 'simulation/getByName',
            addFavs: 'favorites/add',
            removeFavs: 'favorites/remove',
            getSimulations: 'simulation/get',
            repeatSimulation: 'simulation/repeatSimulation',
            getFilter: 'simulation/getFilter'
        }),
        markSvgs(ref) {
            const target = this.$refs[`${ref}`]; 
            this.sorkMarks.forEach(el => {
                el.classList.remove('history-item__sort_active'); 
            });
            target.classList.add('history-item__sort_active');  
        },
        async sort(orderBy, sortedBy) {
            this.markSvgs(`${orderBy}_${sortedBy}`); 
             
            this.params.orderBy = orderBy;
            this.params.sortedBy = sortedBy;
            this.resetCurrentPage();  

            await this.getFilter(); 
            this.clearRefs();  
        },
        clearRefs() {
            for (const key in this.$refs) { 
                const element = this.$refs[key]; 

                if (element.length == 0) {
                    delete this.$refs[key];
                }
            }
        },
        async openTab(item) {    
            const id = item.id;
            const name = item.db_schema;

            const refs = Object.values(this.$refs)
                .filter(item => { 
                    if (!(item instanceof Node)) {
                        return item;
                    } 
                });       
            
            refs.forEach(element => {    
                if(element.length == 0) {
                    return;
                }
 
                const fElement = element[0].$el;
                  
                if(!fElement) {
                    return;
                }   
                
                if(fElement.classList.contains('history-item__body_show') && !fElement.classList.contains(`history-item_${id}`)) { 
                    fElement.classList.remove('history-item__body_show'); 
                }
            }); 

            if(!this.$refs.hasOwnProperty(`history-item__body_${id}`)) {
                return;
            } 
            
            const el = this.$refs[`history-item__body_${id}`][0].$el; 
            
            if(el.classList.contains('history-item__body_show')) {
                el.classList.toggle('history-item__body_hide');

                setTimeout(() => {
                    el.classList.toggle('history-item__body_hide');
                    el.classList.toggle('history-item__body_show');
                }, 200);
                return;
            } 
             
            el.classList.toggle('history-item__body_show');
        },
        async addToCompare($event, id) { 
            const element = $event.target.closest(".add-to-compare");
             
            if(element.classList.contains('add-to-compare_show')) { 
                this.removeCompare(id);
            }
            else { 
                this.compare(id); 
            }
             
            element.classList.toggle('add-to-compare_show');
        },
        async addToFavs($event, id) { 
            const element = $event.target.closest(".add-to-favs");

            if(element.classList.contains('add-to-favs_show')) { 
                this.removeFavs(id);
            }
            else { 
                this.addFavs(id);
            }
             
            element.classList.toggle('add-to-favs_show');
        },
        async handleScroll({target: {offsetHeight, scrollTop, scrollHeight}}) {  
            let allowGetRequest = true;

            if(!allowGetRequest) {
                return;
            } 

            if(offsetHeight + scrollTop >= scrollHeight) {   
                await this.getSimulations();
                allowGetRequest = false; 
                
                setTimeout(() => {
                    allowGetRequest = true;
                }, 300);
            }
        }
    }, 
    mounted() {
        this.sorkMarks = document.querySelectorAll('.history-item__sort_mark');
    }
}
</script>

<style lang="scss">
@import '@/assets/scss/animation.scss';

.history {
    &-items {
        height: 67vh;
        overflow-y: auto;
    }

    &-item {
        width: 100%; 
        padding: 10px;
        border-bottom: 1px solid rgba(178, 180, 183, 0.25);
        border-radius: 4px;
            
        &_head {
            
            .history-item__nav {
                padding: 3px 10px !important;
            }
        }   

        &__parameters {
            display: flex;
            width: 100%;
        }

        &__left {
            width: 90%;
            padding-right: 15px;
        }

        &__right {
            width: 40%;
            border-left: 1px solid #f5f5f5;
            padding-left: 15px;
        }

        &__head {
            width: 100%; 
            cursor: pointer;
            display: flex;
            align-items: center;
            user-select: none; 
        }
        
        &_p0 {
            padding: 0;
        }

        &__nav {    
            display: flex;
            width: 88%;
            align-items: center;
            padding: 10px;
        }

        &__actions {
            display: flex;
            width: 12%;
        }

        &__sort {
            display: flex;
            flex-direction: column;
            height: 100%;

            span {
                height: 10px !important;
                display: inline-block;
                margin: 2.5px;
                margin-left: 5px;
            }

            svg {
                width: 10px;
                height: 10px;
            }

            path {
                fill: #000;
            }

            &_desc {
                transform: rotate(180deg);
            }

            &_active {
                path {
                    fill: #ffd703;
                }
            }
        }

        &__body { 
            width: 100%; 
            display: none;
            min-height: 260px;
            height: auto;
            padding-bottom: 50px;
            padding: 10px 0; 
            overflow-y: auto;

            &_show {
                display: flex;
                animation: showTab .2s ease-out;
            }

            &_hide {
                animation: hideTab .25s ease-out;
            }

            &_p10 {
                padding-left: 10px;
                padding-right: 10px;
            }

            &_bb {
                border-top: 1px solid rgba(178, 180, 183, 0.25);
            }
        }

        &__dashboard {
            margin-right: 10px; 
        }
    
        &__id {
            width: 70px;
            padding-left: 10px;
            // text-align: center;
        }

        &__service {
            width: 10%;
            // text-align: center;
        }

        &__days {
            width: 7%;
            padding-left: 2%;
        }

        &__orders {
            width: 10%;
            // text-align: center;
        }

        &__masters {
            width: 10%;
            // text-align: center;
        }

        &__cof {
            width: 15%;
            display: flex;
            align-items: center;
            // text-align: center;
        }

        &__date {
            width: 10%;
            // text-align: center; 16, 15, 12, 13
        }

        &__ul {
            width: 91.5%;
        }

        &__li {
            width: inherit;
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 8px;

            &_mb {
                margin-bottom: 16px;
            }

            span {
                font-weight: 500;
                font-size: 13px;
            }

            &_date {
                text-align: right;
            }
        }

        &__title { 
            font-size: 24px;
            margin-bottom: 20px;

            &_mb {
                margin-bottom: 12px;
            }

            &_mt {
                margin-top: 12px;
            }
        }
    } 
}
 

.clear-btn {
    outline: none;
    border: none;
    background-color: transparent;
    cursor: pointer;
    margin-right: 10px;
    padding: 0;
}

.add-to-compare {  
    &_show {
        path {
            fill: rgb(255,215,0);
        } 
    }
}

.add-to-favs_show {
    path {
        fill: red;
    }
}

.sectors {
    margin-bottom: 20px;
}

.hr {
    width: 100%;
    height: 1.5px;
    background-color:#f5f5f5;
    margin: 15px 0;
}

.info {
    background-color: #fff;
    height: auto;
    overflow-y: auto;
    margin-bottom: 20px;
    margin-right: 10px;
    box-sizing: border-box;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16); 
    
    &__item {
        display: flex;
        font-size: 14px;
        color: #444;
        margin-bottom: 5px; 
        padding: 15px;
        &:first-child {
            background-color: rgba(97, 66, 45, 0.05);
        }
    }

    &_head {
        font-weight: 600;
        font-size: 15px;
        color: #000;
        padding: 15px;
    }

    &__working {    
        width: 22%;
    }

    span {
        color: dimgray;
    }

    &__sold {
        width: 22%;
    } 

    &__no-orders {
        width: 30%;
    }   

    &__avg {
        width: 35%;
    }

    &__new-clients,
    &__by-ads  {
        width: 22%;
    } 

    &__by-refferal {
        width: 30%;
    }
}

.sector {
    display: flex;
    font-size: 13px;
    margin-bottom: 8px;

    &_head {
        font-size: 14px;
        font-weight: 600;
    }
    
    &__name {
        width: 20%;
    }

    &__cof {
        width: 20%;
    }

    &__masters {
        width: 20%;
    }

    &__end {
        width: 20%;
    }

    &__start {
        width: 20%;
    }
}
 

@media (max-width: 1900px) {
    .history {
        &-items {
            height: 72vh;
            overflow-y: auto;
        } 
    }
}


@media (max-width: 1600px) {
    .history {
        &-items {
            height: 67vh;
            overflow-y: auto;
        } 
    }
}

@media (max-width: 1440px) {
    .history {
        &-items {
            height: 60vh;
            overflow-y: auto;
        } 
    }
}
</style>